<script setup lang="ts">
import {useTemplateRef} from "vue";
import Menu from "primevue/menu";
import {Icon} from "@iconify/vue";

const menu = useTemplateRef("menu");

defineExpose({menu});
</script>
<template>
    <Menu ref="menu">
        <template #itemicon="{item}">
            <Icon :icon="item.icon" class="mr-1.5" width="20" />
        </template>
    </Menu>
</template>
<style scoped></style>
